import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardSecurityCodeInputOptionsAriaLabel from './cardSecurityCodeInputOptionsAriaLabel.mdx';
import CardSecurityCodeInputOptionsCardNetwork from './cardSecurityCodeInputOptionsCardNetwork.mdx';
import CardSecurityCodeInputOptionsContainer from './cardSecurityCodeInputOptionsContainer.mdx';
import CardSecurityCodeInputOptionsId from './cardSecurityCodeInputOptionsId.mdx';
import CardSecurityCodeInputOptionsName from './cardSecurityCodeInputOptionsName.mdx';
import CardSecurityCodeInputOptionsPlaceholder from './cardSecurityCodeInputOptionsPlaceholder.mdx';
import CardSecurityCodeInputOptionsPlacement from './cardSecurityCodeInputOptionsPlacement.mdx';
import CardSecurityCodeInputOptionsProperties from './cardSecurityCodeInputOptionsProperties.mdx';
import CardSecurityCodeInputOptionsStyle from './cardSecurityCodeInputOptionsStyle.mdx';
import CvvInputFrame from './cvvInputFrame.mdx';
import CvvInputMetadata from './cvvInputMetadata.mdx';
import CvvInputName from './cvvInputName.mdx';
import CvvInputValueToken from './cvvInputValueToken.mdx';
import CvvInputAddListener from './cvvInputAddListener.mdx';
import CvvInputBlur from './cvvInputBlur.mdx';
import CvvInputFocus from './cvvInputFocus.mdx';
import CvvInputRemove from './cvvInputRemove.mdx';
import CvvInputRemoveListener from './cvvInputRemoveListener.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Create a `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{` that can be used to safely pass the secure code associated to a vaulted card to Primer's backend.`}</p>
    <p>{`For security reasons, the input is rendered in an iframe on Primer's domain and you won't be able to access programmatically the value stored in the input.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const vaultManager = headless.createVaultManager()

// ... retrieve payment methods with fetchVaultedPaymentMethods

const cvvInput = await vaultManager.createCvvInput({
    cardNetwork: vaultedPaymentMethod.paymentInstrumentData.network,
    container: '#foo',
    name: 'cvv',
    style,
    placeholder: '123',
})

// Somewhere else in your code, create a \`submitButton\` to start the payment
// and a \`cvvError\` container to show validation errors

submitButton.onclick = () => {
    // use metadata to show error messages
    cvvError.innerText = cvvInput.metadata.error ?? ''
    // don't start the payment flow if the \`CVVInput\` is in an invalid state
    if (cvvInput.metadata.error) return
    try {
        vaultManager.startPaymentFlow(vaultedPaymentMethod.id, {
            cvv: cvvInput.valueToken,
        })
    } catch (error) {
        // handle errors
    }
}
`}</code></pre>
    <h5>{`Parameters:`}</h5>
    <Group summary='CardSecurityCodeInputOptions' mdxType="Group">
    <Item title='container' subtitle='string' mdxType="Item">
        <CardSecurityCodeInputOptionsContainer mdxType="CardSecurityCodeInputOptionsContainer" />
    </Item>
	<Item title='ariaLabel' subtitle='Optional<string>' mdxType="Item">
        <CardSecurityCodeInputOptionsAriaLabel mdxType="CardSecurityCodeInputOptionsAriaLabel" />
    </Item>
    <Item title='id' subtitle='Optional<string>' mdxType="Item">
        <CardSecurityCodeInputOptionsId mdxType="CardSecurityCodeInputOptionsId" />
    </Item>
    <Item title='name' subtitle='Optional<string>' mdxType="Item">
        <CardSecurityCodeInputOptionsName mdxType="CardSecurityCodeInputOptionsName" />
    </Item>
    <Item title='placeholder' subtitle='Optional<string>' mdxType="Item">
        <CardSecurityCodeInputOptionsPlaceholder mdxType="CardSecurityCodeInputOptionsPlaceholder" />
    </Item>
    <Item title='placement' subtitle="Optional<'append' | 'prepend'>" mdxType="Item">
        <CardSecurityCodeInputOptionsPlacement mdxType="CardSecurityCodeInputOptionsPlacement" />
    </Item>
    <Item title='properties' subtitle='Optional<Object>' mdxType="Item">
        <CardSecurityCodeInputOptionsProperties mdxType="CardSecurityCodeInputOptionsProperties" />
    </Item>
    <Item title='style' subtitle='Optional<CheckoutStyle>' mdxType="Item">
        <CardSecurityCodeInputOptionsStyle mdxType="CardSecurityCodeInputOptionsStyle" />
    </Item>
    <Item title='cardNetwork' subtitle='Optional<string>' mdxType="Item">
        <CardSecurityCodeInputOptionsCardNetwork mdxType="CardSecurityCodeInputOptionsCardNetwork" />
    </Item>
    </Group>
    <h5>{`Returns:`}</h5>
    <Group summary='CvvInput' mdxType="Group">
	<Item title='valueToken' subtitle='string' mdxType="Item">
		<CvvInputValueToken mdxType="CvvInputValueToken" />
	</Item>
	<Item title='addListener' subtitle="(event: 'change' | 'focus' | 'blur', listener: Function) => Function" mdxType="Item">
		<CvvInputAddListener mdxType="CvvInputAddListener" />
	</Item>
      <Item title='addEventListener' subtitle="(event: 'change' | 'focus' | 'blur', listener: Function) => Function" mdxType="Item">
        <p>{`Alias of `}<a parentName="p" {...{
            "href": "#headlessvaultmanager.createCvvInput-cvvinput.addListener"
          }}>{`addListener`}</a></p>
      </Item>
      <Item title='removeListener' subtitle="(event: 'change' | 'focus' | 'blur', listener: Function) => void" mdxType="Item">
  <CvvInputRemoveListener mdxType="CvvInputRemoveListener" />
      </Item>
      <Item title='focus' subtitle='() => void' mdxType="Item">
  <CvvInputFocus mdxType="CvvInputFocus" />
      </Item>
      <Item title='blur' subtitle='() => void' mdxType="Item">
  <CvvInputBlur mdxType="CvvInputBlur" />
      </Item>
      <Item title='remove' subtitle='() => {}' mdxType="Item">
  <CvvInputRemove mdxType="CvvInputRemove" />
      </Item>
      <Item title='frame' subtitle='HTMLIFrameElement' mdxType="Item">
  <CvvInputFrame mdxType="CvvInputFrame" />
      </Item>
      <Item title='metadata' subtitle='InputMetadata' mdxType="Item">
  <CvvInputMetadata mdxType="CvvInputMetadata" />
      </Item>
      <Item title='name' subtitle='string' mdxType="Item">
  <CvvInputName mdxType="CvvInputName" />
      </Item>
    </Group>
    <h5>{`Errors:`}</h5>
    <p>{`If the `}<inlineCode parentName="p">{`container`}</inlineCode>{` passed in the parameters is not found and the `}<inlineCode parentName="p">{`CVVInput`}</inlineCode>{` cannot be mounted, the promise is resolved with `}<inlineCode parentName="p">{`null`}</inlineCode>{` and an error message is logged to the developer's console.`}</p>
    <h5>{`Example:`}</h5>
    <p>{`Wrap a `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{` in a React component using `}<inlineCode parentName="p">{`addListener('change', listener)`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const CvvInput = ({ onChange }) => {
    useEffect(() => {
        const cvvInput = headless.createCvvInput({
            cardNetwork: vaultedPaymentMethod.paymentInstrumentData.network,
            container: '#foo',
            name: 'cvv',
            style,
            placeholder: '123',
        })
        cvvInput.addListener('change', onChange)
    }, [])

    return <div id='foo' />
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const CardForm = () => {
    const vaultManager = useVaultManager()
    const selectedVaultedPaymentMethod = useSelectedVaultedPaymentMethod()

    const [cvv, setCvv] = useState('')

    return (
        <div>
            <CvvInput onChange={value => setCvv(value)} />
            <SubmitButton onClick={() => vaultManager.startPaymentFlow(vaultedPaymentMethod.id, { cvv })} />
        </div>
    )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      